// Timezone-safe date utilities for YYYY-MM-DD date strings.
//
// Background: new Date('2026-06-15') is parsed as UTC midnight. In negative-offset
// timezones (Toronto/NY) this displays as the previous day. These helpers parse
// the date components manually so the Date always sits at local midnight of the
// intended calendar day — matching what the user typed.

export const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;
  // Accept "YYYY-MM-DD" or "YYYY-MM-DDTHH:mm:ss" — take the date portion only
  const datePart = String(dateStr).split('T')[0];
  const [y, m, d] = datePart.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

export const formatLocalDate = (dateStr, options = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }) => {
  const date = parseLocalDate(dateStr);
  if (!date) return '';
  return date.toLocaleDateString('en-US', options);
};
